import { AnyAction, createAsyncThunk } from '@reduxjs/toolkit';
import { sportApi } from 'features/api/sportApiSlice';
import { FetchPayload, doFetch } from 'features/api/thunkUtils';
import {
  LiveFavouriteItem,
  removeAvvenimentoFromFavouriteList,
} from 'features/live/liveInternalLayout/liveFavouriteAvvenimentoSlice';
import { selectLiveAvvenimentoList } from 'features/live/liveInternalLayout/selectors';
import { ScommessaResponse } from 'lib/api/sport/sportScommesseBySlugResponse';
import { RootState } from 'lib/centralStore';
import { LIVE_FAVOURITE_DETAILS, LiveNavActionPayload } from '../../types';

export const openFavourites = createAsyncThunk(
  'openFavourites',
  async (_: LiveNavActionPayload, { getState, dispatch }): Promise<Array<LiveFavouriteItem>> => {
    const result: LiveFavouriteItem[] = [];

    const promises: Promise<AnyAction>[] = [];
    const state = getState() as RootState;
    const liveAvvenimentoList = selectLiveAvvenimentoList()(state);

    if (liveAvvenimentoList.length > 0) {
      for (let avvenimento of liveAvvenimentoList) {
        result.push(avvenimento);
        const { slugAvvenimento } = avvenimento;
        const prAvvenimento = dispatch(
          doFetch({
            uid: LIVE_FAVOURITE_DETAILS,
            slug: slugAvvenimento,
            query: sportApi.endpoints.getAvvenimento,
          })
        );
        promises.push(prAvvenimento as unknown as Promise<AnyAction>);
      }

      const apiResults = await Promise.all(promises);

      for (let idx = apiResults.length; idx > 0; ) {
        idx--;
        const apiResult = Reflect.get(apiResults[idx], 'payload') as FetchPayload<ScommessaResponse>;
        if (!apiResult.data) {
          // remove from results
          result.splice(idx, 1);
          // remove from favourites
          dispatch(removeAvvenimentoFromFavouriteList({ keyAvvenimento: liveAvvenimentoList[idx].keyAvvenimento }));
        }
      }
    }

    return Promise.resolve(result);
  }
);

export const closeFavourites = createAsyncThunk(
  'closeFavourites',
  async (_: LiveNavActionPayload): Promise<void> => Promise.resolve()
);
